import { createNamedContext } from '@/utils';
import type { PaletteEditorContextValue, ThemeGroupContextValue, ThemeGroupSelectContextValue } from './interfaces';

export const PaletteEditorContext = createNamedContext<PaletteEditorContextValue>(undefined, 'ColorPalette.Editor.Context');
export const ThemeGroupContext = createNamedContext<ThemeGroupContextValue>(undefined, 'ThemeGroup.Context');
export const ThemeGroupSelectContext = createNamedContext<ThemeGroupSelectContextValue>(undefined, 'ThemeGroup.Select.Context');